// src/features/products/components/ProductGrid.tsx
import React from 'react';
import { Grid } from '@mui/material';
import { Product } from '../types';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: Product[];
  onProductClick?: (product: Product) => void;
}

export const ProductGrid: React.FC<ProductGridProps> = ({ 
  products, 
  onProductClick 
}) => {
  return (
    <Grid container spacing={3}>
      {products.map((product) => (
        <Grid 
          key={product.id}
          size={{ xs: 6, sm: 6, md: 4, lg: 3 }}
        >
          <ProductCard 
            product={product}
            onClick={() => onProductClick?.(product)}
          />
        </Grid>
      ))}
    </Grid>
  );
};